import { createSlice } from "@reduxjs/toolkit";
import TransactionMonitorService from "../../../app/data/transaction-monitor/transactionMonitorService";
import { IState } from "../..";
import { AppThunk } from "../../../app/store";
import { initialTransactionMessageIssueState } from "./TransactionMessagesState";

const transactionMonitorService = TransactionMonitorService.getInstance();

export const transactionMessageIssueSlice = createSlice({
  name: "transactionMessageIssue",
  initialState: initialTransactionMessageIssueState,
  reducers: {
    resetTransactionMessageIssue: (state) => initialTransactionMessageIssueState,
    transactionMessageIssueLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    transactionMessageIssueLoadingSucceed: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.id = payload.id;
      state.severity = payload.severity;
      state.errorDetails = payload.errorDetails;
      state.createdAt = payload.createdAt;
      state.createdBy = payload.createdBy;
    },
    transactionMessageIssueLoadingFailed: (state) => {
      state.loading = false;
      state.loadingFailed = true;
      state.id = initialTransactionMessageIssueState.id;
      state.severity = initialTransactionMessageIssueState.severity;
      state.errorDetails = initialTransactionMessageIssueState.errorDetails;
      state.createdAt = initialTransactionMessageIssueState.createdAt;
      state.createdBy = initialTransactionMessageIssueState.createdBy;
    },
  },
});

export const {
  resetTransactionMessageIssue,
  transactionMessageIssueLoadingStarted,
  transactionMessageIssueLoadingSucceed,
  transactionMessageIssueLoadingFailed,
} = transactionMessageIssueSlice.actions;

export const transactionMessageIssueSelector = (state: IState) => state.transactionMessageIssue;

export const getTransactionMessageIssueDetails = (
  messageId: string
): AppThunk => async (dispatch) => {
  dispatch(transactionMessageIssueLoadingStarted());

  const response = await transactionMonitorService.getIssueDetails(messageId);

  if (response.ok()) {
    dispatch(transactionMessageIssueLoadingSucceed(response.data));
  } else {
    dispatch(transactionMessageIssueLoadingFailed());
  }
};

const transactionMessageIssueReducer = transactionMessageIssueSlice.reducer;
export default transactionMessageIssueReducer;
